import { type TaskMetadataWithReviewQuestion } from '@exam-management/graphql';
import { Flex, PaperSection, ReadonlyField } from '@shared/components';

import { useQuestionReviewTaskDetails } from '../../providers';
import { QuestionList } from '../question-list';

export default function TaskQuestionDetailsSection() {
  const { taskDetails } = useQuestionReviewTaskDetails();

  const hasParentTask = !!taskDetails.parentTask?.id;

  const qbsName = hasParentTask
    ? (taskDetails.parentTask?.metadata as TaskMetadataWithReviewQuestion)?.qBankStructure?.name
    : (taskDetails.metadata as TaskMetadataWithReviewQuestion)?.qBankStructure?.name;

  return (
    <PaperSection title='Question Details'>
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), p: theme.spacing(6) })}
      >
        <ReadonlyField label='คลังข้อสอบ' content={qbsName ?? '-'} />
        <QuestionList />
      </Flex>
    </PaperSection>
  );
}
